<template>
    <button :class="{'arrow-button': true, 'left-arrow': direction === 'left'}" data-testid="arrow-button" :aria-label="ariaLabel" @click="onClick">
        <ArrowIcon />
    </button>
</template>

<script setup lang="ts">
    import ArrowIcon from '~/assets/svg/arrow.svg';

    interface Props {
        direction?: 'left' | 'right';
        onClick: () => void;
        ariaLabel?: string;
    }

    withDefaults(defineProps<Props>(), {
        direction: 'right',
        ariaLabel: '',
    });
</script>

<style lang="scss">
    .arrow-button {
        @include flex-row-justify-center;
        align-items: center;
        background-color: var(--joy-color-neutral-0);
        border: $border var(--joy-color-secondary-50);
        border-radius: var(--joy-core-radius-6);
        width: 48px;
        height: 48px;
        margin-right: 10px;
        cursor: pointer;
        transition: all var(--joy-transition-duration-default) var(--joy-transition-timing-function);

        &.left-arrow {
            transform: rotate(180deg);
        }

        &:hover {
            background-color: var(--joy-color-secondary-50);
        }

        path {
            stroke: var(--joy-color-secondary-50);
            transition: stroke var(--joy-transition-duration-default) var(--joy-transition-timing-function);
        }

        &:hover path {
            stroke: $color-white;
        }
    }
</style>
